import type { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import AccountBootstrap from './AccountBootstrap';
import { Toaster } from 'sonner';
import { currentAccount, useAccountSession } from './accountSession';
export { scopedStorage } from './standaloneStorage';

const visitor = { user_id: '', name: '', avatar: '' };
export const getCurrentUserProfile = () => {
  const user = currentAccount();
  return user ? { user_id: user.id, name: user.name, avatar: '' } : visitor;
};
export const useCurrentUserProfile = () => {
  useAccountSession();
  return getCurrentUserProfile();
};
export const ActiveLink = NavLink;
export const avatarImages = {};
export const logger = {
  info: (...values: unknown[]) => console.info(...values),
  warn: (...values: unknown[]) => console.warn(...values),
  error: (...values: unknown[]) => console.error(...values),
  debug: (...values: unknown[]) => console.debug(...values),
};

export function AppContainer({ children }: PropsWithChildren) {
  return <><AccountBootstrap>{children}</AccountBootstrap><Toaster position="top-center" richColors /></>;
}

export function ErrorRender({ error, resetErrorBoundary }: {
  error: unknown;
  resetErrorBoundary: () => void;
}) {
  console.error(error);
  return <div role="alert" className="p-6 text-center">
    <p>页面加载遇到问题，请重试。</p>
    <button className="mt-4 rounded-xl bg-primary px-4 py-2 text-white" onClick={resetErrorBoundary}>
      重试
    </button>
  </div>;
}

export function resolveAppUrl(value: string): string {
  return new URL(value.startsWith('/') || /^https?:/.test(value) ? value : '/' + value,
    window.location.origin).toString();
}
